import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withPreloading, withRouterConfig } from '@angular/router';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { GlobalErrorHandler } from './core/error-handler/global-error-handler';
import { graphqlProvider } from './core/graphql/services';
import { ActualRouteInterceptor } from './core/interceptors/actual-route.interceptor';
import { HttpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { pipesProvider } from './core/pipes/services/pipes.provider';
import { AppPreloadingStrategy } from './core/strategies/app-preloading.strategy';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(
			routes,
			withPreloading(AppPreloadingStrategy),
			withRouterConfig({
				onSameUrlNavigation: 'reload',
			}),
		),
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimations(),
		provideToastr({
			positionClass: 'toast-top-center',
		}),
		provideEnvironmentNgxMask(),
		graphqlProvider,
		pipesProvider,
		{ provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ActualRouteInterceptor, multi: true },
		{ provide: ErrorHandler, useClass: GlobalErrorHandler },
	],
};
